import {
  Carousel,
  CarouselContent,
  CarouselPrevious,
  CarouselNext,
  CarouselProps,
  cn,
} from '@wellesley/ui'
import { FC, PropsWithChildren } from 'react'
import { useSliderDots } from 'hooks/useSliderDots'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import useDisableBrowserSwipe from 'hooks/useDisableBrowserSwipe'
import { useKeyboardNavigation } from 'hooks/slider/useKeyboardNavigation'

type CmpProps = PropsWithChildren<{
  mediaCount: number
  wrapperClass?: string
  contentClass?: string
  containerWidth?: number
  renderSlides: (current: number) => JSX.Element | null
}> &
  Pick<CarouselProps, 'opts'>

const SliderWithBottomControls: FC<CmpProps> = ({
  opts,
  mediaCount,
  wrapperClass,
  contentClass,
  renderSlides,
}) => {
  const [setApi, Dots, api, current] = useSliderDots(mediaCount)
  const [hoverRef, isHovered] = useDisableBrowserSwipe()
  useKeyboardNavigation({ api, canNavigate: isHovered })

  const isActive = opts?.active && mediaCount > 1

  return (
    <Carousel
      setApi={setApi}
      ref={hoverRef}
      className="w-full overflow-hidden "
      opts={{
        align: 'start',
        active: isActive,
        ...opts,
      }}
      plugins={[WheelGesturesPlugin()]}
    >
      <CarouselContent className={cn('items-end', contentClass)}>
        {renderSlides(current)}
      </CarouselContent>
      {isActive && (
        <div
          className={cn('mb-2.5 mt-3 flex items-center', wrapperClass)}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="grow pl-[46px]">
            <Dots />
          </div>
          <div className="h-5">
            <CarouselPrevious variant="bottom" />
            <CarouselNext variant="bottom" />
          </div>
        </div>
      )}
    </Carousel>
  )
}

export default SliderWithBottomControls
